import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { akitaConfig } from '@datorama/akita';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { NgxGoogleAnalyticsModule, provideGoogleAnalytics } from '@hakimio/ngx-google-analytics';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { CoreModule } from './app/core/core.module';
import { environment } from './environments/environment';

registerLocaleData(localeDe, 'de');
registerLocaleData(localeEn, 'en');

akitaConfig({ resettable: true });

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(CoreModule, NgxGoogleAnalyticsModule, environment.production ? [] : AkitaNgDevtools.forRoot()),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideGoogleAnalytics(environment.googleAnalyticsTrackingId),
    provideAnimations(),
  ],
}).catch((err) => console.error(err));
